
import React from 'react';
// import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'

const renderFromHelper = ({ touched, error }) => {
  if (!(touched && error)) {
    return
  } else {
    return <FormHelperText>{touched && error}</FormHelperText>
  }
}
const renderSelectField = ({
    input,
    label,
    meta: { touched, error },
    children,
    classes,
    value,
    ...custom
  }) => (
    <FormControl  error={touched && error} style = { { width: '100%'}}>
        <InputLabel htmlFor="age-native-simple">{label}</InputLabel>
        <Select
          native
          fullWidth
          {...input}
          {...custom}
          value={value}
          inputProps={{
            name: 'age',
            id: 'age-native-simple'
          }}
        >
          {children}
        </Select>
        {renderFromHelper({ touched, error })}
    </FormControl>
  )

/* renderSelectField.propTypes = {
     
}; */

export default renderSelectField;